<!-- <div class="account-pages my-5 pt-sm-5">
    <video muted="true" autoplay="autoplay" playsinline loop id="myVideo" oncanplay="this.play()" onloadedmetadata="this.muted = true">
        <source  src="assets/images/loginvideo.mp4" type="video/mp4">
        </video>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card_2 overflow-hidden">
                    <div class="bg-soft bg-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4"> -->

<div class="login-page">
    <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container">
            <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>
        </div> <!-- end of container -->
    </nav>
    <div class="login-left">
        <div class="left-login">


            <div>
                <div class="text-primary  ">
                    <h5 id="reg" class="text-primary welcome-title"> Reset Password</h5>
                    <p id="para" class="welcome-subtitle">Reset-Password with Connekkt Xchange.</p>
                </div>
            </div>
            <!-- <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
            </div> -->
            <!-- </div> -->
            <!-- </div> -->
            <div>
                <!-- <div>
            <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-light">
                        <img src="assets/images/connekkt-web-logo-black.png" alt="" class="rounded-circle" height="16">
                    </span>
                </div>
            </a>
        </div> -->
                <!-- <form class="login-form" [formGroup]="resetForm" (ngSubmit)="onSubmit()"> -->

                <!-- <label>Enter Password</label>
        <input formControlName="newPassword" type="password" placeholder="New password" /> -->

                <!-- <div class="form-group ">
                        <label class="control-label">Enter Password<span style="color: crimson;">*</span></label>
                        <input [type]="hide ? 'password' : 'text'" type="password" formControlName="password"
                            required="required" class="form-control password" />
                        <button class="btn btn-light ms-0" (click)="showPassword()" type="button" id="password-addon"> -->
                <!-- <i
                                                                    class="mdi mdi-eye-outline"></i> -->
                <!-- <img src="assets/newImages/eyebutton.png" alt="">
                        </button>
                        <div class="invalidError" *ngIf="(registerForm.get('password').invalid && formDir.submitted)">
                            Password is required, must be alphanumeric, and at least
                            6
                            characters long</div> -->


                <!-- </div>

                    <label>Confirm Password</label>
                    <input formControlName="confirmPassword" type="password" placeholder="Confirm password" />

                    <button class="login-btn" type="submit">Reset Password</button> -->

                <!-- <p class="back-text"><a (click)="setMode('login')">Back to Login</a></p> -->
                <!-- </form> -->
               <form class="needs-validation login-form" name="resetForm" [formGroup]="resetForm" (ngSubmit)="onSubmit()"
                    novalidate>

                    <ngb-alert type="danger" *ngIf="error" [dismissible]="false">{{ error }}</ngb-alert>
                    <ngb-alert type="success" *ngIf="success" [dismissible]="false">{{ success }}</ngb-alert>

                    <div class="form-group">
                        <label class="control-label">Enter Password</label>
                        <input maxlength="100" [type]="hide ? 'password' : 'text'" type="password"
                            formControlName="password" required="required" class="form-control"
                            placeholder="Enter Password"
                            [ngClass]="{ 'is-invalid': submitted && f.rpassword.errors }" />
                        <button class="btn btn-light ms-0" (click)="showPassword()" type="button" id="password-addon">
                            <!-- <i
                                                                    class="mdi mdi-eye-outline"></i> -->
                            <img src="assets/newImages/eyebutton.png" alt="">
                        </button>
                        <div class="invalidError" *ngIf="(resetForm.get('password').invalid && submitted)">Password is
                            required*
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label">Confirm Password</label>
                        <input maxlength="100" [type]="hides ? 'password' : 'text'" type="password"
                            formControlName="rpassword" required="required" class="form-control"
                            placeholder="Re-Enter Password"
                            [ngClass]="{ 'is-invalid': submitted && f.rpassword.errors }" />
                        <button class="btn btn-light ms-0" (click)="showPassword2()" type="button" id="password-addon">
                            <img src="assets/newImages/eyebutton.png" alt="">

                            <!-- <i
                                                                    class="mdi mdi-eye-outline"></i> -->
                        </button>
                        <div *ngIf="(resetForm.get('rpassword').invalid && submitted)" class="invalidError">Retype
                            Password is
                            required*</div>
                        <div *ngIf="resetForm.get('rpassword').dirty" class="invalidError">
                            <span *ngIf="resetForm.errors?.invalid"> Password doesn't match* </span>
                        </div>
                    </div>


                    <!-- <div class="text-end"> -->
                          <button class="login-btn btn btn-primary" type="submit">Change Password</button>
                    <!-- <button class="btn" type="submit">Change Password</button> -->
                    <!-- </div> -->
                </form>
                <div class="mt-1 ">
                    <p>Remember It ? <a routerLink="/account/login" class="fw-medium text-primary"> Sign In here</a>
                    </p>
                    <!-- <p>© {{year}} Content Market Place. Crafted with <i class="mdi mdi-heart text-danger"></i> by Connekkt Xchange</p> -->
                </div>
            </div> <!-- end card-body-->

        </div>
        <div class="login-footer">© 2025 Content Market Place. Crafted with <i class="mdi mdi-heart text-danger"></i>  by Connekkt Xchange</div>

    </div>
    <div class="login-right">
        <div class="poster-overlay"></div>
        <p class="right-text">Lead your content to global success with us.</p>
    </div>
    <!-- end card -->


</div> <!-- end col -->
<!-- </div> -->
<!-- end row -->
<!-- </div> -->
<!-- end container -->
<!-- </div> -->
<!-- end page -->